import api from '../BaseUrl';
import { AboutMe } from '../Client/PublicResponse';

export type { AboutMe };

export const getAboutMe = async (): Promise<AboutMe | null> => {
  const res = await api.get<AboutMe | AboutMe[]>('/api/AboutMe/GetAboutMe');
  return Array.isArray(res.data) ? res.data[0] ?? null : res.data;
};

export const updateAboutMe = async (data: AboutMe): Promise<void> => {
  await api.post('/api/Admin/UpdateAboutMe', data);
};
